import init from '../../helpers/init';

const {$} = init;

$(() => {
  $('.js-consent-modal button').on('click', (e: JQuery.ClickEvent) => {
    e.preventDefault();
    const isAgree = $(e.currentTarget).data('agree');

    $('.js-agree-checkbox').prop('checked', isAgree);
    $('.js-consent-modal').modal('hide');
  });
});
